import axios from 'axios';

/**
 * Fetches localized texts from the API and dispatches them to the Redux store.
 *
 * @param {Function} dispatch - The Redux dispatch function to send actions to the store.
 * @param {Function} setTextsAction - The Redux action creator for setting texts in the store.
 * @param {string} currentLanguage - The current language code (e.g., "pl", "en") to be sent in the request headers.
 *
 * @returns {Promise<void>} A promise that resolves when the texts are successfully fetched and dispatched.
 *
 * @example
 * import { useDispatch } from 'react-redux';
 * import getTexts from './fetchTexts';
 * import { setTexts } from '../store/reducers/textsReducer';
 *
 * const dispatch = useDispatch();
 * const currentLanguage = 'en';
 *
 * useEffect(() => {
 *   getTexts(dispatch, setTexts, currentLanguage);
 * }, [dispatch, currentLanguage]);
 */

const getTexts = async (dispatch, setTextsAction, currentLanguage) => {
    
    const url = 'https://api.lightpass.gradis.pl/api/config/texts';

    try {
        const response = await axios.get(url, {
            headers: {
                'Accept-Language': currentLanguage,
            },
        });
        dispatch(setTextsAction(response.data));
    } catch (error) {
        console.error("Get data error: ", error);
    }
};

export default getTexts;